import axios, {AxiosError, AxiosResponse} from 'axios';
import {IngredientObject} from './types';
import {ErrorObject} from 'types';
import queryString from 'query-string';

export interface GetIngredientsParams {
  title?: IngredientObject['title'];
  skip?: string;
  limit?: string;
  my?: string;
}

/**
 * Create ingredient in the store.
 * @param {Omit<IngredientObject, "id">} ingredient
 * @return {Promise<IngredientObject | ErrorObject | undefined>}
 */
export async function createIngredient(ingredient: Omit<IngredientObject, 'id'>) {
  return axios({
    method: 'POST',
    url: `${process.env.REACT_APP_API_BASE_URL}/ingredients`,
    data: JSON.stringify(ingredient),
  }).then((response: AxiosResponse<IngredientObject>) => (
    response.data
  )).catch((error: AxiosError<ErrorObject>) => (
    error.response?.data
  ));
}

/**
 * Get ingredient by id from the store.
 * @param {IngredientObject["id"]} id
 * @return {Promise<IngredientObject | ErrorObject | undefined>}
 */
export async function getIngredientByID(id: IngredientObject['id']) {
  return axios({
    method: 'GET',
    url: `${process.env.REACT_APP_API_BASE_URL}/ingredients/${id}`,
  }).then((response: AxiosResponse<IngredientObject>) => (
    response.data
  )).catch((error: AxiosError<ErrorObject>) => (
    error.response?.data
  ));
}

/**
 * Get all ingredients from the store.
 * @return {Promise<IngredientObject[] | ErrorObject | undefined>}
 */
export async function getIngredients(params?: GetIngredientsParams) {
  return axios({
    method: 'GET',
    url: queryString.stringifyUrl({
      url: `${process.env.REACT_APP_API_BASE_URL}/ingredients`,
      query: params && {
        ...params,
      },
    }),
  }).then((response: AxiosResponse<IngredientObject[]>) => (
    response.data
  )).catch((error: AxiosError<ErrorObject>) => (
    error.response?.data
  ));
}

/**
 * Delete ingredient by id from the store.
 * @param {IngredientObject["id"]} id
 * @return {Promise<boolean | ErrorObject | undefined>}
 */
export async function deleteIngredientByID(id: IngredientObject['id']) {
  return axios({
    method: 'DELETE',
    url: `${process.env.REACT_APP_API_BASE_URL}/ingredients/${id}`,
  }).then((response: AxiosResponse<boolean>) => (
    response.data
  )).catch((error: AxiosError<ErrorObject>) => (
    error.response?.data
  ));
}
